export default function DownloadCTA() {
  return (
    <section id="download" className="w-full py-20 md:py-28 bg-background-50 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20gradient%20technology%20background%20with%20soft%20warm%20orange%20and%20cream%20tones%2C%20flowing%20curved%20lines%2C%20minimalist%20clean%20design%2C%20digital%20abstract%20art%2C%20subtle%20light%20pattern%20overlay%2C%20professional%20modern%20aesthetic%2C%20elegant%20atmosphere&width=1920&height=600&seq=cta-bg-91&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-background-50/85" />

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-6">
          完全免费
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-5">
          立即获取91免费版
        </h2>
        <p className="text-foreground-600 mb-10 max-w-xl mx-auto text-base leading-relaxed">
          无需注册，无需付费，一键下载。海量免费软件任你使用，安全纯净、实时更新，即刻开启高效数字生活。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="inline-flex items-center px-10 py-4 text-base font-semibold whitespace-nowrap rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all duration-300 cursor-pointer">
            <i className="ri-download-cloud-2-line mr-2 text-lg" />
            Windows版下载
          </button>
          <button className="inline-flex items-center px-10 py-4 text-base font-semibold whitespace-nowrap rounded-full border-2 border-primary-200 text-primary-600 hover:bg-primary-50 transition-all duration-300 cursor-pointer">
            <i className="ri-apple-line mr-2 text-lg" />
            macOS版下载
          </button>
        </div>

        <p className="mt-6 text-xs text-foreground-400">
          支持 Windows 7/8/10/11 · macOS 10.15+ · 兼容x86/x64/ARM架构
        </p>
      </div>
    </section>
  );
}